module.exports = __webpack_public_path__ + "static/media/circle-icon.03ceba93.svg";